import type { Getter, Setter } from 'jotai';
import type { UndoRedoActionCommand } from '../../../../../modernization-common/undo-redo/types';
import type { AddEdgePayload } from '../../../types/skeleton-template-builder.type';
import { templateEdgesAtom } from '../template-atoms';
export const addEdgeCommandFactory = (get: Getter, set: Setter): UndoRedoActionCommand<AddEdgePayload, void> => {
  return {
    execute: payload => {
      const {
        edge
      } = payload;
      set(templateEdgesAtom, [...get(templateEdgesAtom), edge]);
    },
    undo: payload => {
      const {
        edge
      } = payload;
      set(templateEdgesAtom, get(templateEdgesAtom).filter(e => !(e.sourceNodeId === edge.sourceNodeId && e.targetNodeId === edge.targetNodeId)));
    }
  };
};